export default __webpack_public_path__ + "c509d26f555fb0d3ad8c3e29382c196b.gif";